import {Box} from "@mui/system";
import {TextField} from "@mui/material";
import RecommendedSettingDropdown from "./RecommendedSettingDropdown";
import {COLORS} from "../../../ui/Theme";
import AddIcon from "@mui/icons-material/Add";
import RecommendedSettingDelete from "./RecommendedSettingDelete";
import {useRecommendedContext} from "../../../context/recommended/RecommendedContext";

const RecommendedSettingForm = ({handleOpenAddModal}) => {

    const {
        config,
        tableData,
        editedName,
        setEditedName,
    } = useRecommendedContext();

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "20px",
                    width: "100%",
                }}
            >
                {/* TextField */}
                <TextField
                    value={config.isValidating ? "" : editedName}
                    onChange={(e) => setEditedName(e.target.value)}
                    placeholder={
                        config.isValidating
                            ? "در حال بارگذاری..."
                            : "نام تنظیمات..."
                    }
                    disabled={config.isValidating}
                    sx={{
                        width: "250px",
                        height: "46px",
                    }}
                />

                {/* Dropdown and Buttons */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        gap: "10px",
                    }}
                >
                    {/* Dropdown */}
                    <RecommendedSettingDropdown sx={{marginLeft: "auto"}}/>

                    {/* Buttons */}
                    <Box
                        sx={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                        }}
                    >
                        {/* Add Button */}
                        <button
                            disabled={config.isValidating}
                            className="btn btn-softblue"
                            onClick={handleOpenAddModal}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "140px",
                            }}
                        >
                            تنظیمات جدید
                            <AddIcon/>
                        </button>

                        {/* Delete Button */}
                        <RecommendedSettingDelete/>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default RecommendedSettingForm;